const ehsan = {
  ehsanAlertMessage:
    'لانك اخترت تأميني .. تأميني معك بالاحسان\nوثيقة تأمين واحدة تجمع بين الأمان والعطاء.',
  ehsanBannerMessage: 'أثر وثيقتك عبر تأميني يصنع فرقًا بالإحسان.',
  learnMore: 'تعرف على المزيد',
}

export default ehsan
